<template>
    <auth-layout>
        <header-page title="Edit Data Diri"/>
        <loading-block v-if="loading" />
        <div v-else>
            <div class="form-edit-profile">
                <upload-avatar :user="user" @changed="handleChangeAvatar"/>
                <div class="form-group">
                    <label for="username">Username</label>
                    <input type="text" class="form-control clean-form" v-bind:class="errors.hasOwnProperty('username') ? 'is-invalid' : ''" id="username" v-model="form.username" disabled>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('username')">
                        {{ errors.username }}
                    </div>
                </div>
                <div class="form-group">
                    <label for="email">Email</label>
                    <input type="email" class="form-control clean-form" id="email" v-bind:class="errors.hasOwnProperty('email') ? 'is-invalid' : ''" v-model="form.email">
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('email')">
                        {{ errors.email }}
                    </div>
                </div>
                <hr/>
                <header-element title="Nama Lengkap"/>
                <div class="form-group">
                    <label for="nama_depan">Nama Depan</label>
                    <input type="text" class="form-control clean-form" id="nama_depan" v-bind:class="errors.hasOwnProperty('first_name') ? 'is-invalid' : ''" v-model="form.first_name">
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('first_name')">
                        {{ errors.first_name }}
                    </div>
                </div>
                <div class="form-group">
                    <label for="nama_belakang">Nama Belakang</label>
                    <input type="text" class="form-control clean-form" id="nama_belakang" v-bind:class="errors.hasOwnProperty('last_name') ? 'is-invalid' : ''" v-model="form.last_name">
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('last_name')">
                        {{ errors.last_name }}
                    </div>
                </div>
                <div class="form-group">
                    <label for="bio">Bio</label>
                    <textarea class="form-control clean-form" id="bio" rows="3" v-model="form.bio" v-bind:class="errors.hasOwnProperty('bio') ? 'is-invalid' : ''">{{ user.bio }}</textarea>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('bio')">
                        {{ errors.bio }}
                    </div>
                    <span class="limiter" v-if="form.bio">{{ 100 - form.bio.length }} karakter tersisa.</span>
                </div>
                <hr/>
                <div class="form-group">
                    <label for="pekerjaan">Pekerjaan</label>
                  <!--   <input type="text" class="form-control clean-form" id="pekerjaan" v-bind:class="errors.hasOwnProperty('work') ? 'is-invalid' : ''" v-model="form.work"> -->
                    <select class="form-control clean-form" id="job_id" @change="changeJobs" v-bind:class="errors.hasOwnProperty('job_id') ? 'is-invalid' : ''" v-model="form.job_id">
                                <option value="0">Pilih Pekerjaan</option>
                                <option v-for="item in form.list_job" :value="item.id">{{ item.name }}</option>
                            </select>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('job_id')">
                        {{ errors.job_id }}
                    </div>
                </div>
                <div class="form-group col-md-6" v-show="ShowWork"></div>
                        <div class="form-group col-md-6" v-show="ShowWork">
                        <label for="no_handphone" class="">Alternatif Pekerjaan Lainnya</label>
                        <input type="text" class="form-control clean-form" id="pekerjaan" placeholder="Isi Pekerjaan Lainnya" v-bind:class="errors.hasOwnProperty('work') ? 'is-invalid' : ''" v-model="form.work">
                </div>
                <div class="form-group">
                    <label for="no_handphone" class="">No Handphone</label>
                   
                    <input type="text" class="form-control  clean-form" id="no_handphone" v-bind:class="errors.hasOwnProperty('phone') ? 'is-invalid' : ''" v-model="form.phone">
                    <span class="sample">Contoh pengisian format 08112640632</span>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('phone')">
                        {{ errors.phone }}
                    </div>
                </div>
                <div class="form-group">
                    <label for="jenis_kelamin">Jenis Kelamin</label>
                    <select class="form-control clean-form" id="jenis_kelamin" v-bind:class="errors.hasOwnProperty('gender') ? 'is-invalid' : ''" v-model="form.gender">
                        <option value="2">Laki - laki</option>
                        <option value="1">Perempuan</option>
                    </select>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('gender')">
                        {{ errors.gender }}
                    </div>
                </div>
                <div class="form-group">
                    <label for="tanggal_lahir">Tanggal Lahir</label>
                    <date-picker v-model="form.birthday" id="tanggal_lahir" valueType="format" format="DD-MM-YYYY" v-bind:class="errors.hasOwnProperty('birthday') ? 'is-invalid' : ''"></date-picker>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('birthday')">
                        {{ errors.birthday }}
                    </div>
                </div>
                <div v-if="form.register_log =='arkadiame'">
                    <label for="interests">Interest</label>
                    <multiselect id="interests" v-model="form.interests" :options="interests" track-by="name" label="name" :multiple="true" v-bind:class="errors.hasOwnProperty('interests') ? 'is-invalid' : ''"></multiselect>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('interests')">
                        {{ errors.interests }}
                    </div>
                </div>
                <hr/>
                <header-element title="Alamat Lengkap"/>
                <div class="form-group">
                    <label for="alamat">Alamat</label>
                    <textarea class="form-control clean-form" id="alamat" rows="3" v-model="form.address" v-bind:class="errors.hasOwnProperty('address') ? 'is-invalid' : ''">{{ user.address }}</textarea>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('address')">
                        {{ errors.address }}
                    </div>
                </div>
                <div class="form-group">
                    <label for="provinsi">Provinsi</label>
                    <select class="form-control clean-form" id="provinsi" @change="changeProvince" v-model="form.province_id" v-bind:class="errors.hasOwnProperty('province_id') ? 'is-invalid' : ''">
                        <option value=""></option>
                        <option v-for="item in province" :value="item.id">{{ item.name }}</option>
                    </select>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('province_id')">
                        {{ errors.province_id }}
                    </div>
                </div>
                <div class="form-group">
                    <label for="kota">Kota</label>
                    <select class="form-control clean-form" id="kota" v-model="form.regency_id" :disabled="!form.province_id" v-bind:class="errors.hasOwnProperty('regency_id') ? 'is-invalid' : ''">
                        <option value=""></option>
                        <option v-for="item in regency" :value="item.id">{{ item.name }}</option>
                    </select>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('regency_id')">
                        {{ errors.regency_id }}
                    </div>
                </div>
                <hr/>
                <header-element v-if="form.register_log =='arkadiame'" title="Media Sosial"/>
                <div class="row" v-if="form.register_log =='arkadiame'">
                        <div class="form-group col-md-6 dotted-sosmed">
                            <div class="form-group col-md-8 pull-left">  
                                <label for="facebook">Facebook</label>
                                <input type="text" class="form-control  clean-form" id="facebook" v-model="form.facebook" v-bind:class="errors.hasOwnProperty('facebook') ? 'is-invalid' : ''">
                                <span class="sample">Format: yoursay_id (tanpa @)</span>
                                <div class="invalid-feedback" v-if="errors.hasOwnProperty('facebook')">
                                    {{ errors.facebook }}
                                </div>
                            </div>
                            <div class="form-group col-md-4 pull-left">  
                               <label for="facebook">Follower</label> 
                               <input type="number" class="form-control  clean-form" id="facebook_follower" v-model="form.facebook_follower" v-bind:class="errors.hasOwnProperty('facebook_follower') ? 'is-invalid' : ''">

                               <div class="invalid-feedback full pull-left" v-if="errors.hasOwnProperty('facebook_follower')">
                                    {{ errors.facebook_follower }}
                               </div>
                            </div>   
                        </div>
                        <div class="form-group col-md-6 dotted-sosmed">
                            <div class="form-group col-md-8 pull-left">    
                                <label for="instagram">Instagram</label>
                                <input type="text" class="form-control clean-form" id="instagram" v-model="form.instagram" v-bind:class="errors.hasOwnProperty('instagram') ? 'is-invalid' : ''">
                                 <span class="sample">Format: yoursay_id (tanpa @)</span>
                                <div class="invalid-feedback" v-if="errors.hasOwnProperty('instagram')">
                                    {{ errors.instagram }}
                                </div>


                            </div>      

                            <div class="form-group col-md-4 pull-left">
                                 <label for="instagram">Follower</label>
                                <input type="number" class="form-control clean-form" id="instagram_follower" v-model="form.instagram_follower" v-bind:class="errors.hasOwnProperty('facebook') ? 'is-invalid' : ''">

                                <div class="invalid-feedback full pull-left" v-if="errors.hasOwnProperty('facebook_follower')">
                                    {{ errors.facebook_follower }}
                                </div>
                            </div>    
                        </div>

                        <div class="form-group col-md-6 dotted-sosmed">
                            <div class="form-group col-md-8 pull-left">  
                                <label for="facebook">Twitter</label>
                                <input type="text" class="form-control  clean-form" id="twitter" v-model="form.twitter" v-bind:class="errors.hasOwnProperty('twitter') ? 'is-invalid' : ''">
                                 <span class="sample">Format: yoursay_id (tanpa @)</span>
                                <div class="invalid-feedback" v-if="errors.hasOwnProperty('twitter')">
                                    {{ errors.twitter }}
                                </div>
                            </div>
                            <div class="form-group col-md-4 pull-left">  
                               <label for="facebook">Follower</label> 
                               <input type="number" class="form-control  clean-form" id="twitter_follower" v-model="form.twitter_follower" v-bind:class="errors.hasOwnProperty('twitter_follower') ? 'is-invalid' : ''">
                               <div class="invalid-feedback full pull-left" v-if="errors.hasOwnProperty('facebook_follower')">
                                    {{ errors.facebook_follower }}
                               </div>
                            </div>   
                        </div>

                        <div class="form-group col-md-6 dotted-sosmed">
                            <div class="form-group col-md-8 pull-left">  
                                <label for="facebook">Tiktok</label>
                                <input type="text" class="form-control  clean-form" id="tiktok" v-model="form.tiktok" v-bind:class="errors.hasOwnProperty('tiktok') ? 'is-invalid' : ''">
                                <span class="sample">Format: yoursay_id (pakai @)</span>
                                <div class="invalid-feedback" v-if="errors.hasOwnProperty('tiktok')">
                                    {{ errors.tiktok }}
                                </div>
                            </div>
                            <div class="form-group col-md-4 pull-left">  
                               <label for="facebook">Follower</label> 
                               <input type="number" class="form-control  clean-form" id="tiktok_follower" v-model="form.tiktok_follower" v-bind:class="errors.hasOwnProperty('tiktok_follower') ? 'is-invalid' : ''">
                                <div class="invalid-feedback full pull-left" v-if="errors.hasOwnProperty('facebook_follower')">
                                    {{ errors.facebook_follower }}
                                </div> 
                            </div>   
                        </div>

                        
                        
                    </div>
            </div>
            <div class="recaptcha-wrap" v-bind:class="errors.hasOwnProperty('recaptcha') ? 'error' : ''">
                <vue-recaptcha ref="recaptcha" sitekey="6LewCUwcAAAAAI5TXwwxnMcqc8_c2SANSbkZmNO1" :loadRecaptchaScript=true @verify="handleRecaptcha"></vue-recaptcha>
                <span>Wajib diisi</span>
            </div>
            <div class="button-wrap">
                <button class="btn btn-primary main-button pill-button bg-orange" @click="handleSubmit">Simpan</button>
                <router-link :to="{ name: 'profile' }" class="btn btn-primary main-button pill-button cancel-button">Batal</router-link>
            </div>
        </div>
    </auth-layout>
</template>
<script>
import axios from "axios";
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    components: { DatePicker, Multiselect },
    data() {
        return {
            user: {},
            province: [],
            regency: [],
            ShowWork:false,
            form: {
                username: '',
                first_name: '',
                email: '',
                last_name: '',
                work: '',
                phone: '',
                gender: '',
                province_id: '',
                regency_id: '',
                birthday: '',
                facebook: '',
                facebook_follower:0,
                instagram: '',
                instagram_follower:0,
                twitter: '',
                twitter_follower:0,
                tiktok:'',
                tiktok_follower:0,
                bio: '',
                interests: null,
                recaptcha: '',
                register_log:'',
                list_job:'',
                job_id:'',
            },
            errors: [],
            loading: true,
            interests: []
        }
    },
    mounted() {
        this.getUser()
        this.getProvince()
        this.getInterest()
    },
    methods: {
        async getUser () {
            const token = this.$cookies.get('token');
            await axios.get('/api/user', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.user = response.data
                    this.form.username = response.data.username
                    this.form.email = response.data.email
                    this.form.first_name = response.data.firstname
                    this.form.last_name = response.data.lastname
                    this.form.work = response.data.work
                    this.form.phone = response.data.phone
                    this.form.gender = response.data.gender
                    if(response.data.brithday && response.data.brithday !== '0000-00-00') {
                        this.form.birthday = moment(response.data.brithday, "YYYY-MM-DD").format("DD-MM-YYYY")
                    }
                    this.form.address = response.data.address
                    this.form.province_id = response.data.province_id
                    this.form.regency_id = response.data.regencie_id
                    this.form.facebook = response.data.facebook
                    this.form.facebook_follower = response.data.facebook_follower
                    this.form.twitter = response.data.twitter
                    this.form.twitter_follower = response.data.twitter_follower
                    this.form.instagram = response.data.instagram
                    this.form.instagram_follower = response.data.instagram_follower
                    this.form.tiktok = response.data.tiktok
                    this.form.tiktok_follower = response.data.tiktok_follower
                    this.form.bio = response.data.bio
                    this.form.list_job = response.data.list_job
                    this.form.job_id = response.data.job_id;
                    this.form.interests = response.data.interests
                    this.form.register_log = response.data.register_log
                    if(response.data.province_id) {
                        this.getRegency(response.data.province_id)
                    }
                    this.loading = false
                })
                .catch((error) => {

                });
        },
        async changeJobs(e){
                 if(e.target.value == '21')
                 {
                    this.ShowWork = true;
                 }else{
                     this.ShowWork = false;
                 }   
        },
        async getInterest() {
            const token = this.$cookies.get('token');
            await axios.get(`/api/interest`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.interests = response.data
                    this.loading = false
                })
                .catch((error) => {

                });
        },
        handleSubmit () {
            const token = this.$cookies.get('token');
            var data = this.form;
            //this.errors = [];
            if( data["birthday"]) {
                data["birthday"] = moment(data["birthday"], "DD-MM-YYYY").format("YYYY-MM-DD");
            }
            ///this.loading = true;
            axios.post('/api/user/change-user', data, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.$notify({
                        duration: 5000,
                        group: 'main',
                        title: 'Berhasil!',
                        text: response.data.message,
                        type: 'success'
                    })
                    this.$router.push({name: 'profile'});
                })
                .catch((error) => {

                    this.errors = error.response.data;
                     
                     // Validasi nomor HP tidak boleh pakai +62
                    if (this.form.phone.startsWith('+62')) {
                        this.errors.phone = 'Nomor HP tidak boleh menggunakan format +62';
                        isValid = false;
                    }

                    // Contoh validasi lainnya (opsional)
                    if (!this.form.phone || this.form.phone === '0') {
                        this.errors.phone = 'Nomor HP tidak boleh kosong atau 0';
                        isValid = false;
                    }

                    // Validasi follower tidak boleh 0 atau '0000000000'
                    const fields = ['facebook_follower', 'instagram_follower', 'twitter_follower', 'tiktok_follower'];
                    fields.forEach((field) => {
                        const val = this.form[field];
                        if (val === 0 || val === '0000000000') {
                            this.errors[field] = 'Jumlah follower tidak boleh 0 atau 0000000000';
                            isValid = false;
                        }
                    });

                    // if(error.response) {
                    //     this.$notify({
                    //         duration: 5000,
                    //         group: 'main',
                    //         title: 'Oopppss!',
                    //         text: error.response.data.message,
                    //         type: 'warn'
                    //     })
                    //     if(error.response.status === 422) {
                    //         this.errors = error.response.data.errors
                    //         window.scrollTo(0,0);
                    //     }
                    // }
                    this.loading = false;
                    // Reset recaptcha for load new
                    this.$refs.recaptcha.reset();
                });
        },
        handleRecaptcha(response) {
            if(response) {
                this.form.recaptcha = response
            }
        },
        handleChangeAvatar(status) {
            if(status) {
                this.getUser();
            }
        },
        getProvince () {
            const token = this.$cookies.get('token');
            axios.get('/api/province', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.province = response.data
                    this.form.regency_id = ''
                })
                .catch((error) => {

                });
        },
        changeProvince(e) {
            this.getRegency(e.target.value)
        },
        getRegency (province_id) {
            const token = this.$cookies.get('token');
            axios.get(`/api/regency?province_id=${province_id}`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.regency = response.data
                })
                .catch((error) => {

                });
        }
    }
}
</script>
<style scoped>
.form-edit-profile {
    padding: 0 5%;
}
.form-group {
    text-align: center;
}
.form-group .mx-datepicker {
    display: block;
    width: 100%;
}
.phone-key{
    width: 18%;
    margin-right: 7px;
} 

.phone-text{
    width: 70%!important;

}
.dotted-sosmed{

    border: 2px dotted #ddd;
    padding: 6px 0px;
    background: #ffffff;
    border-radius: 9px;
}
.sample{
    padding: 5px 0px;
    float: left;
    font-size: 12px;
    color: #991919;
    width: 100%;
}
.form-group .mx-datepicker .mx-input-wrapper .mx-input {
    border-radius: 12px;
}
.mx-datepicker.is-invalid .mx-input-wrapper input {
    border: 1px solid #e3342f;
}
</style>
